import EnTextField from 'Components/inputs/EnTextFieldV2/EnTextFieldV2.vue';
import EnWidgetCard from 'Components/widgets/EnWidgetCard/EnWidgetCard';
import EnOverlaySpinner from 'Components/feedback/EnOverlaySpinner/EnOverlaySpinner';
import EnValidationErrorMessage from 'Components/feedback/EnValidationErrorMessage/EnValidationErrorMessage.vue';
import EnButton from 'Components/base/EnButton/EnButton.vue';
import { getUrlParams } from 'Js/utils/urlUtils';
import { required, validEmail, minLength, maxLength } from 'Js/validation/rules';
import { useSessionStorage } from 'Components/navigation/utils/useSessionStorage';
import { EnButtonVariants } from 'Components/types/EnButtonVariants';
export default {
  __name: 'resetPassword',
  setup(__props, _ref) {
    let __expose = _ref.expose;
    __expose();
    const code = ref('');
    const email = ref('');
    const newPassword = ref('');
    const confirmPassword = ref('');
    const loading = ref(false);
    const errors = ref([]);
    const successRequest = ref(null);
    const form = ref();
    const showPassword = ref(false);
    const _useSessionStorage = useSessionStorage(),
      getIsEnTab = _useSessionStorage.getIsEnTab;
    const isEnTab = computed(() => {
      return getIsEnTab();
    });
    const emailRules = ref([required, validEmail]);
    const passwordRules = ref([required, val => minLength(val, 6), val => maxLength(val, 100), val => /[0-9]/.test(val) || t('Authentication.manage.password.passwordRequiresDigit'), val => /[a-z]/.test(val) || t('Authentication.manage.password.passwordRequiresLower'), val => /[A-Z]/.test(val) || t('Authentication.manage.password.passwordRequiresUpper'), val => /[^A-Za-z0-9]/.test(val) || t('Authentication.manage.password.passwordRequiresNonAlphanumeric')]);
    const confirmPasswordRules = ref([required, val => minLength(val, 6), val => maxLength(val, 100), val => val === newPassword.value || t('Authentication.password.reset.passwordsDoNotMatch')]);
    const isInvalid = computed(() => {
      return !(form.value && form.value.isValid);
    });
    const isInvalidToken = ref(false);
    const backToLoginUrl = computed(() => {
      return "/Account/Login".concat(isEnTab.value ? 'EnTab' : '');
    });
    function togglePasswordVisibility() {
      showPassword.value = !showPassword.value;
    }
    async function sendRequest() {
      loading.value = true;
      errors.value = [];
      isInvalidToken.value = false;
      const response = await fetch("/api/Manage/ResetPassword", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          Email: email.value,
          NewPassword: newPassword.value,
          confirmPassword: confirmPassword.value,
          code: code.value
        })
      });
      if (response.ok) {
        try {
          const result = await response.json();
          if (result.invalidToken === true) {
            errors.value.push(t('Authentication.password.reset.invalidToken'));
            isInvalidToken.value = true;
          } else if (result.errors) {
            errors.value.push(t('Authentication.password.forgot.unexpectedException'));
          } else {
            errors.value = [];
            successRequest.value = true;
          }
        } catch (_unused) {
          errors.value = [];
          successRequest.value = true;
        }
      } else {
        errors.value.push(t('Authentication.password.forgot.unexpectedException'));
      }
      loading.value = false;
    }
    onBeforeMount(async () => {
      const params = getUrlParams(window.location);
      code.value = params['code'];
    });
    onMounted(() => {
      form.value.validate();
    });
    const __returned__ = {
      code,
      email,
      newPassword,
      confirmPassword,
      loading,
      errors,
      successRequest,
      form,
      showPassword,
      getIsEnTab,
      isEnTab,
      emailRules,
      passwordRules,
      confirmPasswordRules,
      isInvalid,
      isInvalidToken,
      backToLoginUrl,
      togglePasswordVisibility,
      sendRequest,
      EnTextField,
      get EnWidgetCard() {
        return EnWidgetCard;
      },
      get EnOverlaySpinner() {
        return EnOverlaySpinner;
      },
      EnValidationErrorMessage,
      EnButton,
      get getUrlParams() {
        return getUrlParams;
      },
      get required() {
        return required;
      },
      get validEmail() {
        return validEmail;
      },
      get minLength() {
        return minLength;
      },
      get maxLength() {
        return maxLength;
      },
      get useSessionStorage() {
        return useSessionStorage;
      },
      get EnButtonVariants() {
        return EnButtonVariants;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};